import React, { useEffect, useState } from 'react'
import md5 from 'js-md5'
import { Toast } from 'antd-mobile'
import { getSelectUserRoleMenus } from '../../api/common'
import _ from 'lodash'

let isPerform = true

/**
 * 元素鉴权
 */
export interface AiPermissionProps {
    permission?: string | string[] // 权限标识列表 空数组也代表不需要权限
    disabledEvent?: string // 需要鉴权的事件名称，不传默认支持onClick,onChange
    disabledType?: 'hidden' | 'disabled' // 禁用类型，默认是disabled，可以设置隐藏，则不渲染
    permissionType?: 'and' | 'or' // 权限类型，默认是or，满足一项即可
}
const AiPermission: React.FC<AiPermissionProps> = props => {
    const [authorized, setAuthorized] = useState<boolean>(false) // 是否有权限
    const _children = props.children[0] || props.children
    
    const _getSelectUserRoleMenus = async() => {
        return new Promise(async (resolve, reject) => {
            try {
                // 每次使用组件都调用一遍权限缓存起来 确保每次都是最新的
                isPerform = false
                const res:any = await getSelectUserRoleMenus()
                const _permission = (res.data || []).map(item => md5(item))
                localStorage.setItem(md5('permission'), JSON.stringify(_permission))
                resolve(_permission)
            } catch (error) {
                isPerform = true
                reject()
            }
        })
    }



    // 点击事件
    const handleClick = async(...args) => {
        if (authorized) {
            if(_.isFunction(_children.props.onClick)) {
                _children.props.onClick(...args)
            }
        }else {
            try {
                await _init()
                if(_.isFunction(_children.props.onChange)) {
                    _children.props.onChange(...args)
                }
            } catch (error) {
                Toast.show('暂无权限操作!')
            }
        }
    }

    // 编辑事件
    const handleChange = async(...args) => {
        if (authorized) {
            if(_.isFunction(_children.props.onChange)) {
                _children.props.onChange(...args)
            }
        }else {
            try {
                await _init()
                if(_.isFunction(_children.props.onChange)) {
                    _children.props.onChange(...args)
                }
            } catch (error) {
                Toast.show('暂无权限操作!')
            }
        }
    }

    // 初始化
    useEffect(() => {
        _init()
    }, [props.permission])
    const _init = async() => {
        return new Promise(async (resolve, reject) => {
            try {
                // 获取当前登录用户的菜单权限列表
                let permissionList:any = localStorage.getItem(md5('permission')) || []
                setAuthorized(false)
                if (!props.permission || !props.permission.length) {
                    setAuthorized(true)
                    resolve(true)
                    return
                }
                if( !permissionList || !permissionList?.length ) {
                    const _res:any = await _getSelectUserRoleMenus()
                    permissionList = _res
                }
    
                const _permission = typeof (props.permission) === 'string' ? [props.permission] : props.permission
                if(props.permissionType === 'and') {
                    setAuthorized(true)
                    resolve(true)
                    _permission.map(item => {
                        if (!permissionList.includes(md5(item))) {
                            // 满足一项即有权限
                            setAuthorized(false)
                            reject(false)
                        }
                    })
                }else {
                    _permission.map(item => {
                        if (permissionList.includes(md5(item))) {
                            // 满足一项即有权限
                            setAuthorized(true)
                            resolve(true)
                        }
                    })
                }
            } catch (error) {
                setAuthorized(false)
                reject(false)
            }
        })
    }
    useEffect(() => {
        if( isPerform ) {
            // 每次使用组件都调用一遍权限缓存起来 确保每次都是最新的
            _getSelectUserRoleMenus()
        }
        return () => {
            isPerform = true
        }
    },[])

    // 重写属性
    let options: any = {
        disabled: !!_children.props.disabled || !authorized,
        title: !authorized ? '无权限操作' : ''
    }
    if(_.isFunction(_children.props.onChange) && !authorized) {
        options.onChange = handleChange
    }

    if(!authorized) {
        options.onClick = handleClick
    }

    if(props.disabledType === 'hidden' && !authorized) {
        return <></>
    }

    return (
        !!props.children && React.cloneElement(_children, { ...options })
    )
}

export default AiPermission

// 通过函数调用的方式来鉴权
export const hasPermission =  (permission?: string | string[], permissionType = 'or', isTotast:boolean = true) => {

    try {
        let permissionList:any = localStorage.getItem(md5('permission')) || []
        if (!permission) {
            return true
        }
        // 如果换成没有权限列表 那么就重新请求权限列表接口
        // if( !permissionList || !permissionList?.length ) {
        //     const res:any = await getSelectUserRoleMenus()
        //     const _permission = (res.data || []).map(item => md5(item))
        //     localStorage.setItem(md5('permission'), JSON.stringify(_permission))
        //     permissionList = localStorage.getItem(md5('permission')) || []
        // }

        const _permission = typeof (permission) === 'string' ? [permission] : permission
        if(permissionType === 'and') {
            // 满足所有
            for(let i = 0; i < _permission.length; i++) {
                if (!permissionList.includes(md5(_permission[i]))) {
                    return false
                }
            }
            return true
        }else {
            // 满足一条即可
            for(let i = 0; i < _permission.length; i++) {
                if (permissionList.includes(md5(_permission[i]))) {
                    return true
                }
            }
        }
        if( isTotast ) {
            Toast.show('暂无权限操作!')
        }
        return false
    } catch (error) {
        console.log(error)
        if( isTotast ) {
            Toast.show('暂无权限操作!')
        }
        return false
    }
}